import { SVGProps } from 'react';

export const CaretIconUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='8'
    height='5'
    viewBox='0 0 8 5'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path d='M0.5 4.5L4 1L7.5 4.5' strokeLinecap='round' />
  </svg>
);
